import * as actionTypes from '../constants/actionTypes';

export const togglePaymentProcessing = (inProgress: boolean) => (dispatch: any) => dispatch({
  type: actionTypes.TOGGLE_PAYMENT_PROCESSING,
  payload: {
    inProgress,
  },
});

export default togglePaymentProcessing;
